import React, { Component } from "react";
import { ReduxConnect, Router } from "../../../../toolkit/decorators/Artifact";
import { Helmet } from "react-helmet";
import ReporteAsesorComponent from "../../../components/comisionesMembresia/reporteAsesor/ReporteAsesor";
import { ReporteAsesorStore, reporteAsesorStore } from "./ReporteAsesor.store";
import {
  ReporteAsesorDispatcher,
  reporteAsesorDispatcher
} from "./ReporteAsesor.dispatcher";
import Layout from "../../../components/layout";

interface Props extends ReporteAsesorStore, ReporteAsesorDispatcher {}
interface State {}

@Router()
@ReduxConnect(reporteAsesorStore, reporteAsesorDispatcher)
export default class ReporteAsesorContainer extends Component<Props, State> {
  render() {
    return (
      <main>
        <Layout>
          <Helmet title="Gestión de incidencias - Membresías" />
          <ReporteAsesorComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
